import styled from 'styled-components';
import { motion } from 'motion/react';

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.surface.primary};
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StyledMain = styled(motion.main)`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
